/**
 * Auth0 custom claim namespace. NOT a real URL and not region-dependent
 */
export const USER_METADATA_URL = "https://api.genira.com/metadata";
